// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Zg_f","title":"Header_title__3_iZD","side":"Header_side__247Qg"};